// sorts a generic type array by any of its attributes. It can be specified if the sorting
// should be done in ascending or descending order.
export const sortByAttribute = <T, K extends keyof T>(array: T[], attribute: K, ascending = true): T[] => {
    const ascNums = ascending ? [-1, 1] : [1, -1];
    return array.sort((a, b) => b[attribute] > a[attribute] ? ascNums[0] : ascNums[1]);
};

export const sortArray = <T>(array: T[], ascending = true) => {
    const ascNums = ascending ? [-1, 1] : [1, -1];
    return array.sort((a, b) => a < b ? ascNums[0] : ascNums[1]);
};